<div class="compliance-container">
	<h2 class="ready-set-header mb-5 d-none d-lg-block">
		Continuous Compliance Solutions Designed <br />
		for Your Organization
	</h2>

	<h2 class="ready-set-header mb-5 d-block d-lg-none">
		Staying Continuously <br />
		Compliant Has Never <br />
		Been Easier
	</h2>

	<div class="row module-cards-grid">
		<div class="col-lg-6 extra-margin mb-5 mb-lg-0">
			<div class="ribbon">
				<img
					src="../../assets/img/blue-ribbon.svg"
					class="ribbon-image"
					alt=""
				/>

				<div class="overlay">
					RegScale Community <br />
					Edition (CE)
				</div>
			</div>

			<div class="regscale-works-card-outer">
				<div
					class="regscale-works-card-inner"
					style="
						background: linear-gradient(
							90deg,
							#1a70ad 0%,
							#2d318d 100%
						);
					"
				>
					<div class="regscale-works-content text-left">
						<div
							class="
								d-flex
								align-items-start
								justify-content-center
							"
						>
							<img
								width="34px"
								src="../../assets/img/apis.svg"
								alt=""
							/>
							<div class="ml-3">
								<strong class="regscale-works-card1"
									>APIs</strong
								>
								<p>
									1000+ APIs allow for real-time assessments
									and integrations with your security and compliance platforms.
								</p>
							</div>
						</div>
						<div><hr /></div>
						<div
							class="
								d-flex
								align-items-start
								justify-content-center
							"
						>
							<img
								width="34px"
								src="../../assets/img/workflow-2.svg"
								alt=""
							/>
							<div class="ml-3">
								<strong class="regscale-works-card1"
									>Workflow
								</strong>
								<p>
									Build drag and drop workflows to automate
									your compliance business processes.
								</p>
							</div>
						</div>

						<div><hr /></div>

						<div
							class="
								d-flex
								align-items-start
								justify-content-center
							"
						>
							<img
								width="34px"
								src="../../assets/img/explorer.svg"
								alt=""
							/>
							<div class="ml-3">
								<strong class="regscale-works-card1"
									>Explorer
								</strong>
								<p>
									Sort and organize your compliance artifacts
									with simple navigation tools to relate your
									compliance data.
								</p>
							</div>
						</div>
						<div><hr /></div>
						<div
							class="
								d-flex
								align-items-start
								justify-content-center
							"
						>
							<img
								width="34px"
								src="../../assets/img/catalogs-2.svg"
								alt=""
							/>
							<div class="ml-3">
								<strong class="regscale-works-card1"
									>Catalogues</strong
								>
								<p>
									Quickly build your artifacts without the
									painful and manual cut/paste processes with
									a growing library of compliance catalogues.
								</p>
							</div>
						</div>
						<div><hr /></div>
						<div
							class="
								d-flex
								align-items-start
								justify-content-center
							"
						>
							<img
								width="34px"
								src="../../assets/img/audit-scheduling.svg"
								alt=""
							/>
							<div class="ml-3">
								<strong class="regscale-works-card1"
									>Audit Scheduling
								</strong>
								<p>
									Schedule audits, track progress, document
									issues (POAMs), and track corrective actions
									to closure.
								</p>
							</div>
						</div>
						<div><hr /></div>
						<div
							class="
								d-flex
								align-items-start
								justify-content-center
							"
						>
							<img
								width="34px"
								src="../../assets/img/evidence-collection.svg"
								alt=""
							/>
							<div class="ml-3">
								<strong class="regscale-works-card1"
									>Evidence Collection
								</strong>
								<p>
									Encrypt audit evidence, control testing
									results, corrective action evidence, and
									related compliance artifacts through
									state-of-the-art security.
								</p>
							</div>
						</div>

						<a
							[routerLink]="['/pricing']"
							class="btn btn-get-started2 btn-raised btn-round"
						>
							Get Started for Free Today
						</a>
					</div>
				</div>
			</div>
		</div>

		<div
			class="col-lg-6 d-flex flex-column align-items-center mt-5 mt-lg-0"
		>
			<img
				class="mb-4"
				src="../../assets/img/community-edition.svg"
				alt=""
			/>
			<div class="ribbon">
				<img
					src="../../assets/img/orange-ribbon.svg"
					class="ribbon-image"
					alt=""
				/>

				<div class="overlay">
					RegScale Enterprise <br />
					Edition (EE)
				</div>
			</div>

			<div class="regscale-works-card-outer">
				<div
					class="regscale-works-card-inner"
					style="
						background: linear-gradient(
							90deg,
							#f3931f 0%,
							#ef5a23 50%,
							#9e0e5d 100%
						);
					"
				>
					<div class="regscale-works-content text-left">
						<div
							class="
								d-flex
								align-items-start
								justify-content-center
							"
						>
							<img
								width="34px"
								src="../../assets/img/time-travel.svg"
								alt=""
							/>
							<div class="ml-3">
								<strong class="regscale-works-card2"
									>Time Travel</strong
								>
								<p>
									View the history of every change to a
									record, travel back in time to see the
									changes in compliance, and roll back to
									previous versions.
								</p>
							</div>
						</div>
						<div><hr /></div>
						<div
							class="
								d-flex
								align-items-start
								justify-content-center
							"
						>
							<img
								width="34px"
								src="../../assets/img/custom-fields-2.svg"
								alt=""
							/>
							<div class="ml-3">
								<strong class="regscale-works-card2"
									>Custom Fields
								</strong>
								<p>
									Extend the functionality of RegScale by
									adding custom fields to each module to match
									your existing business processes and forms.
								</p>
							</div>
						</div>
						<div><hr /></div>
						<div
							class="
								d-flex
								align-items-start
								justify-content-center
							"
						>
							<img
								width="34px"
								src="../../assets/img/multi-tenancy-2.svg"
								alt=""
							/>
							<div class="ml-3">
								<strong class="regscale-works-card2"
									>Multi-Tenancy
								</strong>
								<p>
									Deploy your compliance cloud on premises with
									support for hosting multiple tenants,
									customers, or organizations within a single
									on premises installation.
								</p>
							</div>
						</div>
						<div><hr /></div>
						<div
							class="
								d-flex
								align-items-start
								justify-content-center
							"
						>
							<img
								width="34px"
								src="../../assets/img/integrations.svg"
								alt=""
							/>
							<div class="ml-3">
								<strong class="regscale-works-card2"
									>Integrations</strong
								>
								<p>
									Single Sign-On (SSO) options, AD/LDAP sync, and collaborate
									how and where you want with real-time
									integrations with Slack and Microsoft Teams
									to improve your compliance situational
									awareness.
								</p>
							</div>
						</div>
						<div><hr /></div>
						<div
							class="
								d-flex
								align-items-start
								justify-content-center
							"
						>
							<img
								width="34px"
								src="../../assets/img/individualized-reporting.svg"
								alt=""
							/>
							<div class="ml-3">
								<strong class="regscale-works-card2"
									>Individualized Reporting
								</strong>
								<p>
									Access to a custom PowerBI
									application/dashboard providing advanced
									visualization of compliance data within
									RegScale.
								</p>
							</div>
						</div>
						<div><hr /></div>
						<div
							class="
								d-flex
								align-items-start
								justify-content-center
							"
						>
							<img
								width="34px"
								src="../../assets/img/deployment-flexibility.svg"
								alt=""
							/>
							<div class="ml-3">
								<strong class="regscale-works-card2"
									>Deployment Flexibility
								</strong>
								<p>
									In addition to the standard Linux container
									deployment, EE offers a pre-configured ISO virtual appliance for
									additional flexibility in enterprise
									environments.
								</p>
							</div>
						</div>
						<a
							href="https://go.regscale.com/RegScale-Create-Account"
							class="btn btn-get-started btn-raised btn-round"
						>
							Call Us to Explore Pricing Options
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
